import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { CancelGetIdFormsListFromTemplate } from 'src/app/ricerca/store';
import { AppState, getMyRicerca } from 'src/app/store/app.state';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-spinner-determinate',
  templateUrl: './spinner-determinate.component.html',
  styleUrls: ['./spinner-determinate.component.css']
})
export class SpinnerDeterminateComponent implements OnInit {
  @Input() progressValue: number;

  subs: SubSink = new SubSink();
  constructor(
    public dialogRef: MatDialogRef<SpinnerDeterminateComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: {
      /**Titolo del dialog */
      title: string,
      /**Contenuto del dialog in HTML */
      content: string
    }
    ) { }

  ngOnInit(): void {
    this.subs.sink = this.store.select(getMyRicerca).subscribe(d => {
      if(d.totalLoadingStep !== 0) {
        this.progressValue = Math.floor((d.executedLoadingStep / d.totalLoadingStep) * 100);
        if(this.progressValue === 100) {
          this.dialogRef.close();
        }
      }
    })
  }

  onCancelLoading() {
    this.store.dispatch(new CancelGetIdFormsListFromTemplate());
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
